import { render, staticRenderFns } from "./m_gift_send.vue?vue&type=template&id=899d7350&scoped=true&"
import script from "./m_gift_send.vue?vue&type=script&lang=js&"
export * from "./m_gift_send.vue?vue&type=script&lang=js&"
import style0 from "./m_gift_send.vue?vue&type=style&index=0&id=899d7350&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "899d7350",
  null
  
)

export default component.exports